
export default {
  mounted(el, binding) {
    console.log('mounted', el);
    try {
      el.focus();
    } catch(e) {

    }
  },

};
